import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const userId = localStorage.getItem("UserId");
const roleId = localStorage.getItem("RoleId");

// console.log("localstorage",{...localStorage})


const Goods = () => {

    const [searchInput, setSearchInput] = useState("");
    const [instituteList, setInstituteList] = useState([]);
    const [goodsList, setGoodsList] = useState([]);
    const [sportsList, setSportsList] = useState([]);
    const [coachesList, setCoachesList] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [instituteId, setInstituteId] = useState("");
    const [goodsInstituteId, setGoodsInstituteId] = useState("");
    const [sportsId, setSportsId] = useState("");
    const [cochId, setCochId] = useState("");
    const [prodId, setProdId] = useState("");
    const [quant, setQuant] = useState("");
    const [isueDate, setIsueDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [addInfo, setAddInfo] = useState("");
    const [showGoodsList, setShowGoodsList] = useState(false);
    const [retrn, setRetrn] = useState(false);
    const [openModal, setOpenModal] = useState(false)

    const formRef = useRef(null);

    useEffect(() => {
        institutes();
    }, [])

    function institutes() {
        const getInstitutes = api.InvenInstitutions;
        fetch(getInstitutes, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((invenResponse) => invenResponse.json())
            .then((invenResult) => {
                if (invenResult.code == 401) {
                    Utils.logoutUser();
                }
                setInstituteList(invenResult.data);
            })
            .catch((error) => {
                console.log("Failed to fetch instituteList", error);
            })
    }

    function showList(selectedInst) {
        const getGoodsList = api.GoodsList + '/' + selectedInst //"?institutionId=" + selectedInst;
        fetch(getGoodsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((goodsResponse) => goodsResponse.json())
            .then((goodsResult) => {
                if (goodsResult.code == 401) {
                    Utils.logoutUser();
                }
                if (goodsResult.data != null) {
                    setGoodsList(goodsResult.data)
                }
                setShowGoodsList(true);
            })
            .catch((error) => {
                console.log("Failed to fetch goods list", error)
            })
    }

    function getSports(instId) {
        const getSportsList = api.goodsSportsById + "/" + instId;
        fetch(getSportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sportsResponse) => sportsResponse.json())
            .then((sportsResult) => {
                if (sportsResult.code == 401) {
                    Utils.logoutUser();
                }
                setSportsList(sportsResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch sports list", error)
            })
    }

    function getCoaches(sportId) {
        const getCoachList = api.coachesBySportId + "/" + goodsInstituteId + "/" + sportId;
        fetch(getCoachList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cochResponse) => cochResponse.json())
            .then((cochResult) => {
                if (cochResult.code == 401) {
                    Utils.logoutUser();
                }
                setCoachesList(cochResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch coach list", error)
            })
    }

    function getProducts(sportsId) {
        const getProdList = api.productsBySportsId + "/" + sportsId;
        fetch(getProdList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((prodResponse) => prodResponse.json())
            .then((prodResult) => {
                if (prodResult.code == 401) {
                    Utils.logoutUser();
                }
                setProductsList(prodResult.data)
            })
            .catch((error) => {
                console.log("Failed to fetch product list", error)
            })
    }

    function goodsIssue(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("issueGoodsInstitutionId", goodsInstituteId);
            formData.append("issueGoodsSportsId", sportsId);
            formData.append("issueGoodsCoachId", cochId);
            formData.append("issueGoodsProductId", prodId);
            formData.append("issueGoodsQuantity", quant);
            formData.append("issueGoodsDate", formatDate(isueDate));
            formData.append("issueGoodsRemarks", addInfo);
            // formData.append("issueGoodsBy", userId);

            const saveIsueGoods = api.saveIssueGoods;
            fetch(saveIsueGoods, {
                method: "POST",
                body: formData,
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                }
            })
                .then((isueGoodsResponse) => isueGoodsResponse.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log("Failed to issue goods", error)
                })
        }
    }

    function returnGoods(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("returnGoodsInstitutionId", goodsInstituteId);
            formData.append("returnGoodsSportsId", sportsId);
            formData.append("returnGoodsCoachId", cochId);
            formData.append("returnGoodsProductId", prodId);
            formData.append("returnGoodsQuantity", quant);
            formData.append("returnGoodsDate", formatDate(returnDate));
            formData.append("returnedTo", userId);

            const saveReturnGoods = api.returnGoods;
            fetch(saveReturnGoods, {
                method: "POST",
                body: formData,
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                }
            })
                .then((returnGoodsResponse) => returnGoodsResponse.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }

    const filteredData = goodsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const productRender = (rowData) => {
        return <span>{rowData.ProductName}</span>;
    };

    const quantityRender = (rowData) => {
        return <span>{rowData.issueGoodsQuantity}</span>;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.issueGoodsDate)}</span>;
    };


    const statusRender = (rowData) => {
        return <span>{(rowData.issueGoodsStatus == 0 ? "Issued" : "Returned")}</span>;
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-lg-12">
                                                            <div className="row col-lg-6 court-sortby sortbyset">
                                                                <div className="col-lg-2">
                                                                    <span className="sortbytitle"><h6>Institute</h6></span>
                                                                </div>
                                                                <div className="col-lg-6 sorting-select">
                                                                    <Select
                                                                        value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                                            value: instituteId,
                                                                            label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                                        } : null}
                                                                        onChange={(e) => {
                                                                            setInstituteId(e.value);
                                                                            showList(e.value);
                                                                        }}
                                                                        options={instituteList.map(ins => ({
                                                                            value: ins.institutionId,
                                                                            label: ins.institutionName
                                                                        }))}>
                                                                    </Select>
                                                                </div>
                                                            </div>

                                                            {(roleId == '1' || roleId == '3' || roleId == '5') && (
                                                                <>
                                                                    <div className="col-lg-6">
                                                                        <div className="save-changes text-sm-end">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-secondary save-profile"
                                                                                onClick={() => { setOpenModal(true); setRetrn(false) }}
                                                                            >
                                                                                <i className="fas fa-share" /> &nbsp;
                                                                                Issue Goods
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-secondary save-profile`}
                                                                                onClick={() => { setOpenModal(true); setRetrn(true); }}
                                                                            >
                                                                                <i className="fas fa-redo" /> &nbsp;
                                                                                Return Goods
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        {showGoodsList && (
                                                            <>
                                                                <div className="col-lg-12">
                                                                </div>
                                                                <div className="col-lg-12">
                                                                </div>
                                                                <div className="col-lg-6">
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {showGoodsList && (
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                    pageLinkSize={3}
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="slno"
                                                                        header="Sl No"
                                                                        body={slNoRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="ProductName"
                                                                        header="Product Name"
                                                                        body={productRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="issueGoodsQuantity"
                                                                        header="Quantity"
                                                                        body={quantityRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="issueGoodsDate"
                                                                        header="Issue/ Return Date"
                                                                        body={dateRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="issueGoodsStatus"
                                                                        header="Status"
                                                                        body={statusRender}
                                                                    ></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal custom-modal fade request-modal"
                id="issue-goods"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    <i className="fas fa-truck" />Issue Goods
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12"></div>
                                <div className="row col-lg-12 court-sortby sortbyset">
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                        <Select
                                            value={instituteList.find(ins => ins.institutionId === goodsInstituteId) ? {
                                                value: goodsInstituteId,
                                                label: instituteList.find(ins => ins.institutionId === goodsInstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setGoodsInstituteId(e.value);
                                                getSports(e.value);
                                            }}
                                            options={instituteList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Sport</h6></label>
                                        <Select
                                            value={sportsList.find(sprt => sprt.sportId === sportsId) ? {
                                                value: sportsId,
                                                label: sportsList.find(sprt => sprt.sportId === sportsId).sportName
                                            } : null}
                                            onChange={(e) => {
                                                setSportsId(e.value)
                                                getCoaches(e.value)
                                                getProducts(e.value)
                                            }}
                                            options={sportsList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Coach</h6></label>
                                        <Select
                                            value={coachesList.find(coch => coch.internalUserId === cochId) ? {
                                                value: cochId,
                                                label: coachesList.find(coch => coch.internalUserId === cochId).internalUserFirstName
                                            } : null}
                                            onChange={(e) => {
                                                setCochId(e.value)
                                            }}
                                            options={coachesList.map(coch => ({
                                                value: coch.internalUserId,
                                                label: coch.internalUserFirstName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Product</h6></label>
                                        <Select
                                            value={productsList.find(prdct => prdct.productId === prodId) ? {
                                                value: prodId,
                                                label: productsList.find(prdct => prdct.productId === prodId).productName
                                            } : null}
                                            onChange={(e) => {
                                                setProdId(e.value)
                                            }}
                                            options={productsList.map(prdct => ({
                                                value: prdct.productId,
                                                label: prdct.productName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Quantity</h6></label>
                                        <input
                                            id="quantity"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={quant}
                                            required
                                            onChange={(e) => {
                                                setQuant(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Issue Date</h6></label>
                                        {/* <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={isueDate} onChange={(e) => setIsueDate(e.target.value)}></input> */}
                                        <input
                                            id="issuedate"
                                            className="form-control"
                                            type="date"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={isueDate}
                                            required
                                            onChange={(e) => {
                                                setIsueDate(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Additional Information</h6></label>
                                        <input
                                            id="quantity"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={addInfo}
                                            required
                                            onChange={(e) => {
                                                setAddInfo(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={goodsIssue} data-bs-dismiss="modal" aria-label="Close">
                                    Save
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal custom-modal fade request-modal"
                id="return-goods"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    <i className="fas fa-truck" />Return Goods
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12"></div>
                                <div className="row col-lg-12 court-sortby sortbyset">
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                        <Select
                                            value={instituteList.find(ins => ins.institutionId === goodsInstituteId) ? {
                                                value: goodsInstituteId,
                                                label: instituteList.find(ins => ins.institutionId === goodsInstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setGoodsInstituteId(e.value);
                                                getSports(e.value);
                                            }}
                                            placeholder="Select an Institute"
                                            options={instituteList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Sport</h6></label>
                                        <Select
                                            value={sportsList.find(sprt => sprt.sportId === sportsId) ? {
                                                value: sportsId,
                                                label: sportsList.find(sprt => sprt.sportId === sportsId).sportName
                                            } : null}
                                            onChange={(e) => {
                                                setSportsId(e.value)
                                                getCoaches(e.value)
                                                getProducts(e.value)
                                            }}
                                            options={sportsList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Coach</h6></label>
                                        <Select
                                            value={coachesList.find(coch => coch.internalUserId === cochId) ? {
                                                value: cochId,
                                                label: coachesList.find(coch => coch.internalUserId === cochId).internalUserFirstName
                                            } : null}
                                            onChange={(e) => {
                                                setCochId(e.value)
                                            }}
                                            options={coachesList.map(coch => ({
                                                value: coch.internalUserId,
                                                label: coch.internalUserFirstName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Product</h6></label>
                                        <Select
                                            value={productsList.find(prdct => prdct.productId === prodId) ? {
                                                value: prodId,
                                                label: productsList.find(prdct => prdct.productId === prodId).productName
                                            } : null}
                                            onChange={(e) => {
                                                setProdId(e.value)
                                            }}
                                            options={productsList.map(prdct => ({
                                                value: prdct.productId,
                                                label: prdct.productName
                                            }))}>
                                        </Select>
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Quantity</h6></label>
                                        <input
                                            id="quantity"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={quant}
                                            required
                                            placeholder="Return Quantity"
                                            onChange={(e) => {
                                                setQuant(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Return Date</h6></label>
                                        {/* <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={isueDate} onChange={(e) => setIsueDate(e.target.value)}></input> */}
                                        <input
                                            id="returndate"
                                            className="form-control"
                                            type="date"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={returnDate}
                                            required
                                            placeholder="Date of Return"
                                            onChange={(e) => {
                                                setReturnDate(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={returnGoods} data-bs-dismiss="modal" aria-label="Close">
                                    Save
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    onHide={() => setOpenModal(false)}
                    size="xl"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="fas-fa-truck" />{retrn ? "Return " : "Issue "}Goods</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row col-lg-12 court-sortby sortbyset">
                                <div className="col-lg-6 mb-10">
                                    <label className="sortbytitle"><h6>Institute</h6></label>
                                    <Select
                                        value={instituteList.find(ins => ins.institutionId === goodsInstituteId) ? {
                                            value: goodsInstituteId,
                                            label: instituteList.find(ins => ins.institutionId === goodsInstituteId).institutionName
                                        } : null}
                                        required
                                        onChange={(e) => {
                                            setGoodsInstituteId(e.value);
                                            getSports(e.value);
                                        }}
                                        options={instituteList.map(ins => ({
                                            value: ins.institutionId,
                                            label: ins.institutionName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="sortbytitle"><h6>Sport</h6></label>
                                    <Select
                                        value={sportsList.find(sprt => sprt.sportId === sportsId) ? {
                                            value: sportsId,
                                            label: sportsList.find(sprt => sprt.sportId === sportsId).sportName
                                        } : null}
                                        required
                                        onChange={(e) => {
                                            setSportsId(e.value)
                                            getCoaches(e.value)
                                            getProducts(e.value)
                                        }}
                                        options={sportsList.map(sprt => ({
                                            value: sprt.sportId,
                                            label: sprt.sportName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="sortbytitle"><h6>Coach</h6></label>
                                    <Select
                                        value={coachesList.find(coch => coch.internalUserId === cochId) ? {
                                            value: cochId,
                                            label: coachesList.find(coch => coch.internalUserId === cochId).internalUserFirstName
                                        } : null}
                                        required
                                        onChange={(e) => {
                                            setCochId(e.value)
                                        }}
                                        options={coachesList.map(coch => ({
                                            value: coch.internalUserId,
                                            label: coch.internalUserFirstName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="sortbytitle"><h6>Product</h6></label>
                                    <Select
                                        value={productsList.find(prdct => prdct.productId === prodId) ? {
                                            value: prodId,
                                            label: productsList.find(prdct => prdct.productId === prodId).productName
                                        } : null}
                                        required
                                        onChange={(e) => {
                                            setProdId(e.value)
                                        }}
                                        options={productsList.map(prdct => ({
                                            value: prdct.productId,
                                            label: prdct.productName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <label className="sortbytitle"><h6>Quantity</h6></label>
                                    <input
                                        id="quantity"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                        value={quant}
                                        required
                                        onChange={(e) => {
                                            setQuant(e.target.value)
                                        }}
                                    />
                                </div>
                                {!retrn && (
                                    <>
                                        <div className="col-lg-6 mb-10">
                                            <label className="sortbytitle"><h6>Issue Date</h6></label>
                                            {/* <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={isueDate} onChange={(e) => setIsueDate(e.target.value)}></input> */}
                                            <input
                                                id="issuedate"
                                                className="form-control"
                                                type="date"
                                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                                value={isueDate}
                                                required
                                                onChange={(e) => {
                                                    setIsueDate(e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className="col-lg-6 mb-10">
                                            <label className="sortbytitle"><h6>Additional Information</h6></label>
                                            <input
                                                id="quantity"
                                                className="form-control"
                                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                                value={addInfo}
                                                onChange={(e) => {
                                                    setAddInfo(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                                {retrn && (
                                    <>
                                        <div className="col-lg-6 mb-10">
                                            <label className="sortbytitle"><h6>Return Date</h6></label>
                                            {/* <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={isueDate} onChange={(e) => setIsueDate(e.target.value)}></input> */}
                                            <input
                                                id="returndate"
                                                className="form-control"
                                                type="date"
                                                style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                                value={returnDate}
                                                required
                                                placeholder="Date of Return"
                                                onChange={(e) => {
                                                    setReturnDate(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            type="submit"
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={(e) => { (retrn ? returnGoods(e) : goodsIssue(e)); }}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
};

export default Goods;